import { TableCell, TableHead, TableRow } from '@material-ui/core'
import React from 'react'

export default function SupplierAgreementTableHeader({ useDynamicColumns, columns }) {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Groupe d&apos;accord</TableCell>
        {useDynamicColumns ? (
          columns.map((col) => <TableCell key={`header-${col.id}`}>{col.name}</TableCell>)
        ) : (
          <>
            <TableCell>Taux FB SAS</TableCell>
            <TableCell>Taux FB Filiales</TableCell>
          </>
        )}
        <TableCell>Taux Total</TableCell>
      </TableRow>
    </TableHead>
  )
}
